import * as types from '../mutation-types'
export const moduleId = 'courseDetail';

const state = {
   //课程资源列表
   resourceData:null,
   //是否显示右侧资源列表
   swiperFlag:false,
   //当前选择资源
   currentResource:null,
  //当前资源id
   resourceId:null,
  //是否隐藏右侧资源
  isShowRight:true,
  //是否显示笔记
  isShowNote:false,
  //是否显示切换按钮
  isShowSwitch:false,
  // 笔记列表
  noteData:null


};
const getters = {

};

const mutations = {
  //课程资源列表
  [types.SET_RESOURCE_LIST](state,data){
    state.resourceData = data;
  },
  //是否显示右侧资源列表
  [types.SET_SWIPER_FLAG](state,data){
    state.swiperFlag = data;
  },
  //当前选择资源
  [types.SET_CURRENT_RESOURCE](state,data){
    state.currentResource = data;
  },
  //设置当前资源id
  [types.SET_RESOURCEID](state,data){
    state.resourceId = data;
  },
  //是否隐藏右侧资源
  [types.SET_Right](state,data){
    state.isShowRight = data;
  },
  //是否显示笔记
  [types.SET_NOTE](state,data){
    state.isShowNote = data;
  },
  //是否显示切换按钮
  [types.SET_SWITCH](state,data){
    state.isShowSwitch = data;
  },
  // 笔记列表
	[types.SET_NOTE_LIST](state,data){
    state.noteData = data;
  },
};

const actions = {
   async setResourceList({state,commit},params){

      commit(types.SET_RESOURCE_LIST,params)

   },

   setSwiperFlag({state,commit},params){
     commit(types.SET_SWIPER_FLAG,params)
   },

   setCurrentResource({state,commit},params){
     commit(types.SET_CURRENT_RESOURCE,params)
   },

   setResourceId({state,commit},params){
     commit(types.SET_RESOURCEID,params)
   },

   setRight({state,commit},params){
     commit(types.SET_Right,params)
   },
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/courseDetail.js